<!--
    file type .....: HTML file: req-summary.component.html
    Created By ....: ianday
    Date ..........: 11/15/23 
-->
<div class="req-summary-container">
    <div class="summary-client-area">  <!--RHS Fields -->
        <div class="title-style" style="padding-top: 2px;padding-bottom: 10px;">
            <span>Request Summary</span></div>

        <mat-divider></mat-divider>
		<div class="dwform-row-gap"></div>

        <div class="dwform-row">
            <label class="label-field label-field-override">Request Date:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override">{{requestSummary?.dateCreated | date}}</label>
        </div>

        <div class="dwform-row-gap"></div>

        <div class="dwform-row">
            <label class="label-field label-field-override">Agency:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override">{{requestSummary?.agencyName}}</label>
        </div>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">Status:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override"
                   [ngStyle]="{ 'color': requestSummary?.statusColor }">{{requestSummary?.statusDesc}}</label>
            <span *ngIf="requestSummary?.clericalOpen===1"><label style="margin-left: 6px">(Clerically Opened)</label></span>
        </div>

        <div class="dwform-row-gap"></div>

        <div class="dwform-row">
            <label class="label-field label-field-override">Amount Requested:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override">{{requestSummary?.amountRequested}}
                {{requestSummary?.unitOfMeasure}}</label>
        </div>

        <div *ngIf="_requestStatusId === 3">
            <div class="dwform-row-gap"></div>
            <div class="dwform-row">
                <label class="label-field label-field-override">Amount Provided:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override">{{requestSummary?.totalAmountProvided}}
                    {{requestSummary?.unitOfMeasure}}</label>
            </div>

        </div>
        <div class="dwform-row-gap"></div>

        <div class="dwform-row">
            <label class="label-field label-field-override">Source:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override">{{requestSummary?.source}}</label>
        </div>
        <div class="dwform-row-gap"></div>

        <div class="dwform-row">
            <label class="label-field label-field-override">Date Completed:</label>
            <span class="form-required"> </span>
            <label class="label-field-data label-field-override">
                <span>{{requestSummary?.dateCompleted | date:'mediumDate':'EST'}}
            </span></label>
        </div>
        <div class="dwform-row-gap"></div>
        <!-- Area for Approvals and Contributions -->

        <div [hidden]="_requestStatusId !== 3">
            <div class="dwform-row-gap-half"></div>
            <span style="font-weight: bold;font-size:9pt;">Agency Response(s):</span>
            <div class="dwform-row-gap-half"></div>

            <div class="table-container mat-elevation-z1" id="contributionsTableId"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table class="table-class" mat-table [dataSource]="dataSource" >

                    <!-- Position Column [THIS IS HIDDEN ]-->
                    <ng-container matColumnDef="id" >
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-local" [hidden]="true"
                            style="min-width: 50px;">Id
                        </th>
                        <td mat-cell style="width:50px!important;" [hidden]="true"
                            class="table-detail-style-local"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{element.id}}</td>
                    </ng-container>

                    <!-- Agency Name -->
                    <ng-container matColumnDef="agencyName" >
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-local"
                            style="min-width: 140px;padding-left: 3px;">Agency Name
                        </th>
                        <td mat-cell style="width: 140px!important; padding-left: 3px;"
                            class="table-detail-style-local"
                            *matCellDef="let element">{{getAgencyName(element.agencyId)}}</td>
                    </ng-container>

                    <!-- Commitment -->
                    <ng-container matColumnDef="plannedCommitted" >
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-local"
                            style="min-width: 80px;">Status
                        </th>
                        <td mat-cell style="width:80px!important;"
                            class="table-detail-style-local"
                            *matCellDef="let element">
                            <span
                                  [ngStyle]="{'color': showCommitmentColors(element.plannedCommitted)}">{{element.plannedCommitted}}</span>
                        </td>

                    </ng-container>
                    <!-- Response date -->
                    <ng-container matColumnDef="responseDate" >
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-local"
                            style="min-width: 120px;text-align:center">Response Date
                        </th>
                        <td mat-cell style="width:120px!important;text-align:center"
                            class="table-detail-style-local"
                            *matCellDef="let element">{{element.responseDate | date:'mediumDate':'EST'}}</td>
                    </ng-container>

                    <!-- Amount -->
                    <ng-container matColumnDef="amount" >
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-local"
                            style="width:80px;">Amount
                        </th>

                        <td mat-cell class="mat-table-detail-style"
                            *matCellDef="let element;let tableRowIdx = index;">
                             <span class="table-detail-style-local"
                                  style="width:80px!important">{{element.amountProvided}} {{element.unitOfMeasure}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>


        </div>
        <!-- END APPROVALS and CONTRIBUTIONS -->
    </div>
</div>
